import styled from 'styled-components'
import { Box, getPaletteColor } from 'pcln-design-system'
import { ICellProps } from '../types'

const Cell = styled(Box)`
  vertical-align: top;
  line-height: 1.8;
  text-align: center;
  cursor: pointer;
  color: ${getPaletteColor('border.base')};
  outline-offset: -2px;
  border-radius: ${({ roundedCorners, isStart, isEnd, grouped, theme }: ICellProps) => {
    if (roundedCorners) {
      const r = theme.borderRadii.md
      switch (true) {
        case isStart:
          return `${r} 0 0 ${r}`
        case isEnd:
          return `0 ${r} ${r} 0`
        case grouped:
          return '0'
        default:
          return r
      }
    } else {
      return '0'
    }
  }};
  display: ${({ roundedCorners }: ICellProps) => (roundedCorners ? 'flex' : 'inline-block')};
  align-items: center;
  justify-content: center;
  margin: ${({ roundedCorners }: ICellProps) => (roundedCorners ? '2px' : '0')};
  width: ${({ roundedCorners }: ICellProps) => roundedCorners && 'calc(100% - 4px)'};

  ${(props: ICellProps) => {
    if (!props.valid)
      return `
      cursor: default;
    `
    // This block is for arrow-key navigation, denotes current 'hovered' date (i.e. focused via keys)
    if (props.isCurrentHoverDate && !props.selected)
      return `
      color: ${getPaletteColor('text.dark')(props)};
      outline: 1px solid ${getPaletteColor('primary.base')(props)};

      &:hover {
        background: ${props.isTouch ? 'transparent' : getPaletteColor('primary.light')(props)};
      }
    `
    if (!props.grouped && !props.selected)
      return `
      color: ${getPaletteColor('text.dark')(props)};

      &:focus {
        outline: 1px solid ${getPaletteColor('primary.base')(props)};
      }
      &:hover {
        background: ${props.isTouch ? 'transparent' : getPaletteColor('primary.light')(props)};
        outline: 1px solid ${getPaletteColor('primary.base')(props)};
      }
    `
    if (props.grouped && !props.selected)
      return `
      color: ${getPaletteColor('text.dark')(props)};
      background: ${getPaletteColor('primary.light')(props)};
      outline: 1px dotted ${getPaletteColor('primary.light')(props)};
    `
    if (props.selected)
      return `
      color: ${getPaletteColor('text.lightest')(props)};
      background: ${getPaletteColor('primary.base')(props)};
      border-color: ${getPaletteColor('primary.base')(props)};
      outline: 1px dashed ${getPaletteColor('primary.base')(props)};

      &:focus {
        outline: 2px solid ${getPaletteColor('primary.base')(props)};
        color: ${getPaletteColor('text.base')(props)};
        background: ${getPaletteColor('primary.light')(props)};
      }
    `
  }}
`

export default Cell
